import { enableProdMode } from "@angular/core"
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic"
import { AppModule } from "./app/app.module"
import { AppConstants } from "./app/constants/constants"
import { APP_CONFIG } from "./app/lib/angular/injection-tokens"

function configListener(response: any) {
  try {
    const configuration = JSON.parse(response.target.responseText)

    if (configuration.production) {
      enableProdMode()
    }
    // pass config to bootstrap process using an injection token
    platformBrowserDynamic([{ provide: APP_CONFIG, useValue: configuration }])
      .bootstrapModule(AppModule)
      .catch((err) => console.error(err))
  } catch (error) {
    console.error(error)
  }
}

function configFailed(evt) {
  console.error("Error: retrieving app.config.json")
}

const request = new XMLHttpRequest()
request.addEventListener("load", configListener)
request.addEventListener("error", configFailed)
request.open("GET", AppConstants.CONFIG_PATH)
request.send()
